<template>
  <div>
    <close-button @click="$emit('close')" class="close-button"></close-button>
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="signUpOk">
        <h1>Uw inschrijving is verzonden</h1>
        <p>
          Ter controle is er een validatiemail gestuurd naar {{ user.email }}.
          Via de link in deze email kunt u uw accountaanvraag afronden.
        </p>
      </div>
    </transition>
    <div class="dialog-header">
      <h1>Nieuw bij Rijnja.nl</h1>
    </div>
    <div class="dialog-content">
      <form
        name="signUpForm"
        method="post"
        action="/signUp"
        @submit.prevent="signUp"
      >
        <section class="block">
          <p>
            Vul onderstaande velden in om een Rijnja.nl account aan te maken.
          </p>

          <div class="field-wrapper">
            <div class="label-fix">
              <label for="email">E-mailadres</label>
              <div>
                <input
                  id="email"
                  type="email"
                  name="email"
                  class="grey-field"
                  v-model="user.email"
                  autocomplete="username"
                  :class="{
                    invalid: v$.user.email.$invalid
                  }"
                  @blur="checkUser"
                  autofocus
                />
              </div>
            </div>
          </div>

          <div class="field-wrapper">
            <div class="label-fix">
              <label for="password">Wachtwoord</label>
              <div>
                <password-input
                  v-model="user.password"
                  :password="user.password"
                  :show-hint="true"
                  :invalid="v$.user.password.$invalid"
                  autocomplete="new-password"
                />
              </div>
            </div>
          </div>

          <div class="field-wrapper">
            <div class="label-fix">
              <label for="lastname">Naam</label>
              <div>
                <input
                  class="grey-field"
                  id="lastname"
                  type="text"
                  maxlength="40"
                  name="lastname"
                  v-model="user.name"
                  :class="{
                    invalid: v$.user.name.$invalid
                  }"
                  autocomplete="name"
                />
              </div>
            </div>
          </div>

          <div class="field-wrapper">
            <div class="label-fix">
              <label for="phone">Telefoonnr.</label>
              <div>
                <input
                  class="grey-field"
                  id="phone"
                  type="text"
                  name="phone"
                  v-model="user.phone"
                  :class="{
                    invalid: v$.user.phone.$invalid
                  }"
                  autocomplete="phone"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="block">
          Door op verzenden te klikken, gaat u akkoord met de
          <router-link target="_blank" to="/leveringsvoorwaarden"
            >leveringsvoorwaarden
          </router-link>
          .
        </section>

        <div class="button-holder">
          <p v-show="v$.user.$dirty && v$.$invalid" class="error-text warning">
            Nog niet alle verplichte velden zijn<br />(correct) ingevuld.
          </p>
          <button
            id="confirm-button"
            class="pill-button"
            type="submit"
            v-show="!sending"
            :disabled="v$.$invalid || restricted"
          >
            Verzenden
          </button>
          <bouncing-spinner
            class="spinner-ct"
            v-show="sending"
          ></bouncing-spinner>
        </div>

        <section class="error" v-show="errorMessage.length">
          <span class="error-text">Fout bij verzenden: {{ errorMessage }}</span>
        </section>
        <section class="error" v-show="error">
          <p class="error-text">
            Er is een probleem opgetreden bij het verzenden van uw aanvraag,
            neem contact op met
            <a href="mailto:support@rijnja.nl">support@rijnja.nl</a> of via het
            <span @click="goToContact" class="contact-link pointer"
              >contactformulier</span
            >.
          </p>
        </section>
      </form>
    </div>
  </div>
</template>
<script>
import { required, email, maxLength } from '@vuelidate/validators'
import RegisterRedirect from '@/dialogs/RegisterRedirect.vue'

import { checkRedirect, signUp2 } from '@/api/api'
import PasswordInput from '@/components/ui/PasswordInput.vue'
import { vuelidatePasswordPattern } from '@/api/passwords'
import useVuelidate from '@vuelidate/core'
import { noLetters } from '@/api/validators'

export default {
  components: { PasswordInput },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      signUpOk: false,
      errorMessage: '',
      error: false,
      send: false,
      sending: false,
      user: {
        email: undefined,
        name: undefined,
        phone: undefined,
        password: undefined
      }
    }
  },
  validations: {
    user: {
      email: {
        required,
        email
      },
      name: {
        required
      },
      phone: {
        required,
        noLetters,
        maxLength: maxLength(20)
      },
      password: {
        required,
        vuelidatePasswordPattern
      }
    }
  },
  methods: {
    goToContact() {
      this.$router.push({
        name: 'contact'
      })
      this.$emit('close')
    },
    checkUser() {
      checkRedirect(this.user.email).then((response) => {
        if (
          response &&
          response.redirect.restricted &&
          !response.redirect.allowRegistration
        ) {
          this.restricted = true
          this.$modal.show(
            RegisterRedirect,
            {
              title: response.redirect.title,
              text: response.redirect.message,
              btnLabel: response.redirect.btnLabel,
              btnUrl: response.redirect.btnUrl,
              callback: (url) => {
                if (url === '') {
                  this.$emit('close')
                } else {
                  window.open(response.redirect.btnUrl)
                }
              }
            },
            {
              height: 'auto',
              width: 380,
              adaptive: true
            }
          )
        } else {
          this.restricted = false
        }
      })
    },
    signUp(event) {
      this.sending = true

      signUp2(this.user)
        .then((resp) => {
          this.sending = false
          if (resp.error) {
            this.errorMessage = resp.message
          } else {
            this.signUpOk = true
            setTimeout(() => {
              this.$emit('close')
            }, 6000)
          }
        })
        .catch((error) => {
          this.error = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.field-wrapper {
  margin: 5px 0 15px;
}

.block {
  margin-bottom: 20px;
}

label {
  width: 86px;
  line-height: 34px;
}

.contact-link {
  color: #4f4f4f;
  text-decoration: underline;
}

input {
  width: 240px;
  margin-bottom: 20px;
}

.dialog-content p.warning {
  text-align: left;
  width: 245px;
  padding: 0;
  vertical-align: bottom;
  display: inline-block;
}

.error {
  margin-top: 20px;
}
</style>
